import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { shouldShowFinding } from '../diagnostics/detectionOrigin';

export function useMissedFindings() {
  const showMissed = useSelector((state) => state.images.showMissedFindings);

  const isVisible = useCallback(
    (finding) => shouldShowFinding(finding, showMissed),
    [showMissed]
  );

  return { showMissed, isVisible };
}
